<p-fileUpload
  #fileUploader
  name="myfile[]"
  [multiple]="true"
  [customUpload]="true"
  (uploadHandler)="upload($event, fileUploader)"
  accept=".jpg,.jpeg,.png"
  [maxFileSize]="3000000"
  chooseLabel="Browse"
  [showCancelButton]="true"
  [showUploadButton]="true"
  [fileLimit]="5"
  invalidFileSizeMessageSummary="Images are limited to 3Mb, please compress your image or use a smaller image."
  [auto]="true"
>
  <ng-template let-file pTemplate="file">
    <img [src]="file.objectURL" alt="" class="thumbnail product-image" />
  </ng-template>
  <ng-template pTemplate="content" let-files>
    <div *ngIf="!files.length">Drag and drop image files.</div>
  </ng-template>
</p-fileUpload>

<small>Max File size is 3Mb. Allowed filetypes: .jpg .jpeg or .png</small><br />
<small
  >Renaming a .jfif or .webp file to an allowed filetype will break your
  upload!</small
><br />
<small>Image will be automatically uploaded when chosen</small>
